import { AttachmentLinkEnum } from "@akitabox/api-client";
import { Subject } from "../../../util/Subject";

export interface AttachmentDialogOpenOptions {
  /** Organization id where the attachment dialog is */
  organization: string;
  /** Building id where the attachment dialog may be */
  building: string;
  /**
   * The type of entity attachments should be created for.
   */
  entityType: AttachmentLinkEnum;
  /** The id of the entity to attach documents to */
  entityId: string;
}
export interface AttachmentDialogCloseData {}

export const attachmentDialogOpened =
  new Subject<AttachmentDialogOpenOptions>();

export const attachmentDialogClosed = new Subject<AttachmentDialogCloseData>();
